module.exports = __webpack_public_path__ + "static/media/image01.1aee3da9.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/carousel/en/image01.jpg
 ** module id = 462
 ** module chunks = 0
 **/